import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RfqOutputData, RfqOutputService } from '../rfq-output/rfq-output.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  firstValueFrom,
  lastValueFrom,
  skip,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import {
  RfqDeadlineDialogComponent,
  RfqDeadlineDialogResult,
} from '../rfq-deadline-dialog/rfq-deadline-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ExtendedKeycloakUser,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import moment, { Moment } from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import {
  BodyGetRFQDocument,
  OutputHistories,
  PrintDocument,
  SaveMyPurchase,
} from 'src/app/shared/models/database-models';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { orderBy } from 'lodash';
import { FileService } from 'src/app/shared/services/file.service';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { MatTableDataSource } from '@angular/material/table';
import { MyPurchaseForm, UserInformation } from 'src/app/shared/models/app-models';
import { BodySendRFQs, Vendor } from 'src/app/shared/models/database-models';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { SecurityClassificationId } from 'src/app/shared/models/database-models/SecurityClassification';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';

interface RFQData {
  RFQNumber: string;
  RFQDeadline: Date;
  Reason: string;
  VendorName: string;
  NewRFQDeadline: Date | null;
}

@Component({
  selector: 'app-rfq-update',
  templateUrl: './rfq-update.component.html',
  styleUrls: ['./rfq-update.component.scss'],
  providers: [],
})

export class RfqUpdateComponent implements OnInit, OnDestroy {
  MPDocumentNumber?: string;
  rfqOutputServiceSubscription?: Subscription;
  currentRoute = ['Purchase Modes'];
  currentPageString: string = 'RFQ output';
  purchaseType: string = '';
  KCUserList: ExtendedKeycloakUser[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  RFQDisplayColumns = [
    'RFQNumber',
    'RFQDeadline',
    'NewRFQDeadline',
    'Reason',
    'VendorName',
  ];
  defaultPageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  disabled: boolean = false;
  dpOptions!: StoreDropdowns;
  rfqDataSource: MatTableDataSource<RFQData> = new MatTableDataSource<RFQData>(
    []
  );
  rfqData: RFQData[] = [];
  private rfqPaginator!: MatPaginator;
  @ViewChild('rfqPaginator', { read: MatPaginator }) set matRFQPaginator(
    mp: MatPaginator
  ) {
    this.rfqDataSource.paginator = this.rfqPaginator;
  }
  vendorForm!: Vendor[];
  form!: MyPurchaseForm;
  mpNumber: string = '';
  loggedInUsername: string = '';
  constructor(
    private route: ActivatedRoute,
    public dialogInfoRef: MatDialogRef<DialogComponent>,
    private router: Router,
    private backEndService: BackendApiService,
    public rfqOutputService: RfqOutputService,
    public rfqDeadlineDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private formTransformer: FormTransformerPipe,
    private fileService: FileService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<{ dp: StoreDropdowns ,form: MyPurchaseForm, user: UserInformation }>
  ) {
    if (data.rfqData) this.rfqData = data.rfqData
    this.store.select('form').pipe(takeUntil(this.destroy$)).subscribe((form: MyPurchaseForm) => {
      this.form = form;
      this.mpNumber = form.documentNo || '';
    });
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
      this.loggedInUsername = user.userName;
    })
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (dp: StoreDropdowns) => {
        this.KCUserList = dp.UserList as ExtendedKeycloakUser[];
        this.dpOptions = dp;
        if (!Array.isArray(dp.UserList) || dp.UserList.length === 0) {
          return;
        }
        this.rfqDataSource = new MatTableDataSource<RFQData>(this.rfqData);
      });
  }

  async ngOnInit(): Promise<void> {
    this.rfqDataSource.paginator = this.rfqPaginator;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }


  async updateAndSendRFQ() {
    this.disabled = true;

    // const newRFQDeadlines = this.rfqOutputService.newRFQDeadlines
    // const affectedRFQNumbers = newRFQDeadlines.map(item => item.RFQNumber);
    const newRFQDeadlines = this.rfqDataSource.data.map((rfq) => {
      return {
        RFQDeadline: rfq.RFQDeadline,
        newRFQDeadline: rfq.NewRFQDeadline,
        RFQNumber: rfq.RFQNumber
      }
    });

    let form: SaveMyPurchase = await this.formTransformer.transform(
      this.form,
      this.loggedInUsername,
      this.dpOptions,
    );
    form.rfqDeadlines = newRFQDeadlines
    console.log("neeraj form",form)
    const affectedRFQNumbers = newRFQDeadlines.map(item => item.RFQNumber);
    try {
      await lastValueFrom(
        this.backEndService.generateRFQ(form).pipe(takeUntil(this.destroy$))
      );
      this.openSnackBar('RFQ sent.');
    } catch (err) {
      this.openSnackBar('RFQ failed to send.', 'error');
    }

    let rfqOutput;
    try {
      // Refresh RFQ Output page data, and clear out any stored newRFQDeadline
      rfqOutput = await this.rfqOutputService.onFetchRfqOutput(this.mpNumber);
    } catch (err) {
      console.log(
        'Failed to re-fetch RFQ Output page data after updateAndSendRFQ',
        err
      );
    }

    const rfqItems = (rfqOutput?.data?.RFQ ?? []).filter(rfqItem => affectedRFQNumbers.includes(rfqItem.RFQNumber));
    console.log("neeraj rfqItems",rfqItems)
    try {
      // If MPDocument has high security classification, download RFQs generated as backend will not email RFQs out
      const externalId = this.form.generalForm?.external?.id ?? '';
      if (
        [
          SecurityClassificationId.RESTRICTED,
          SecurityClassificationId.CONFIDENTIAL,
          SecurityClassificationId.SECRET,
        ].includes(externalId as SecurityClassificationId)
      ) {

        if (rfqItems.length > 0) {
          const validUploadPaths = rfqItems
            .map((rfqItem) => rfqItem.UploadPath)
            .filter((str) => !!str) as string[];
          const uniqueUploadPaths = new Set(validUploadPaths);
          await this.fileService.downloadFiles(Array.from(uniqueUploadPaths), {
            isOpenInNewTab: true,
          });
        } else {
          console.log('updateAndSendRFQ did not trigger generated RFQs download as there are no affected RFQ Items', rfqItems);
        }
      }
    } catch (err) {
      console.log(err, rfqOutput, rfqItems);
      this.openSnackBar(
        'Error encountered while downloading the generated RFQs.',
        'error'
      );
    }

    this.disabled = false;
    this.dialogInfoRef.close();
    
  }


  openSnackBar(notifMsg: string, type: string = 'success') {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: "top",
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 3000
    });
  }

  buttonName(){
    const externalId = this.form.generalForm?.external?.id ?? '';
    if (
      [
        SecurityClassificationId.RESTRICTED,
        SecurityClassificationId.CONFIDENTIAL,
        SecurityClassificationId.SECRET,
      ].includes(externalId as SecurityClassificationId)
    )
    {
      return "Print"
    }else{
      return "Email"
    }
  }

}
